export default __webpack_public_path__ + "static/media/Background_00286.f6f7225d.png";